import { render, staticRenderFns } from "./__ClockerSingle.vue?vue&type=template&id=2ab72190"
import script from "./__ClockerSingle.vue?vue&type=script&lang=js"
export * from "./__ClockerSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports